import { Flex } from '@chakra-ui/react';
import React from 'react';

// Exports
type Props = { children: React.ReactNode };
export const SettingsViewTemplate = ({ children }: Props) => {
  return (
    <Flex direction="column" padding={['1.5rem', '1.5rem', '1.5rem', '2.5rem']}>
      {children}
    </Flex>
  );
};
